/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import CustomModal from '../CustomModal/CustomModal';
import ModalHeader from '../CustomModal/ModalHeader';
import { Grid, Box } from '@mui/material';
import CustomAutoComplete from '../../components/CustomAutoComplete/CustomAutoComplete';
import ModalFooter from '../CustomModal/ModalFooter';
import _ from 'lodash';
import Compdirection from '../../themes/CompDirection';
import { DatePickerInput } from '../../../components';
import toast from 'react-hot-toast';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allEmpAssetList: [];
  callBackGetData: (data: any) => void;
  trans?: any;
}

const AddAssetModalPresenter = ({
  isModalOpen,
  closeModal,
  allEmpAssetList,
  callBackGetData,
  trans,
}: ModalProps) => {
  const [EmpAssetTypeId] = useState<any>([]);
  const [asset_list, setasset_list] = useState('');
  const [assignDate, setAssignDate] = useState<any>(null);

  const Handleassetlist = (asset_list: any) => {
    const EmpAssetList = _.filter(allEmpAssetList, function (c: any) {
      return c.asset_id === asset_list;
    });
    if (EmpAssetList.length) {
      const empassetty = EmpAssetList[0];
      EmpAssetTypeId.push(empassetty.id);
      setasset_list(asset_list);
    }
  };

  const handleSubmit = () => {
    if (EmpAssetTypeId?.length === 0 || !assignDate) {
      toast.error('Please fill out required inputs');

      return;
    }

    callBackGetData({
      asset_id: EmpAssetTypeId,
      assign_Date: assignDate,
    });
    closeModal();
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="400px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Assign Assets') }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '10px',
          }}
        >
          <Grid item xs={12}>
            <CustomAutoComplete
              label={trans('Asset List')}
              value={asset_list}
              options={_.map(allEmpAssetList, (EmpAsset: any) => {
                return EmpAsset.asset_id;
              })}
              onChange={(event: any, newValue: any) => {
                Handleassetlist(newValue);
              }}
            />
          </Grid>
          <Grid item xs={12} style={{ marginTop: '0.5em' }}>
            <DatePickerInput
              label={trans('Assign Date')}
              value={new Date(assignDate)}
              width="100%"
              onChange={(newValue: any) => {
                setAssignDate(newValue);
              }}
            />
          </Grid>
        </Grid>
      </Compdirection>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};
export default AddAssetModalPresenter;
